import React, { Fragment, useEffect, useState } from 'react';
import { Button, Col, Container, Input, Row, Table } from 'reactstrap';
import { toast } from "react-toastify";
import _ from 'lodash';
import { FilterSelect, ServiceThreadSpinner } from '.';
import { api, filterHelpers, helpers } from '../utils';
import { confirmAlert } from "react-confirm-alert";

export default function ManageMsrProcesses() {
   const ALL_OPTS = {
      id: -1,
      enabled: false,
      isActive: false,
      label: "-- Select --",
      laborRatePerHour: 0,
      machineRatePerHour: 0,
      overheadRatePerHour: 0,
      process: "",
      stdPkgSize: 0,
      stdPPH: 0,
      stdSpeed: 0,
      stdSpindles: 0,
      step: 0,
      value: -1
   };
   const INIT_MODEL = {
      id: 0,
      enabled: true,
      isActive: true,
      laborRatePerHour: 0,
      machineRatePerHour: 0,
      overheadRatePerHour: 0,
      process: "",
      stdPkgSize: 0,
      stdPPH: 0,
      stdSpeed: 0,
      stdSpindles: 0,
      step: 0
   };
   const [processList, setProcessList] = useState([]);
   const [filters, setFilters] = useState([
      { filterName: "process", value: ALL_OPTS }
   ]);
   const [editId, setEditId] = useState(0);
   const [editProcess, setEdit] = useState(INIT_MODEL);
   const [isAdd, setAdd] = useState(false);
   const [labor, setLabor] = useState(0);
   const [machRate, setMachRate] = useState(0);
   const [newProcess, setNew] = useState(INIT_MODEL);
   const [ohRate, setOverhead] = useState(0);
   const [pkgSize, setPkg] = useState(0);
   const [pph, setPPH] = useState(0);
   const [procName, setName] = useState("");
   const [speed, setSpeed] = useState(0);
   const [spin, setSpinner] = useState(true);
   const [spindles, setSpindles] = useState(0);
   const [step, setStep] = useState(0);

   useEffect(() => {
      runQuery();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   function ActivateProc() {
      if (editId < 1) {
         toast.error("Please select a valid process to activate");
         return;
      }

      setSpinner(true);
      api.post(`MachineSetup/ActivateProcess/${editId}`)
         .then((response) => {
            if (response.data.success) {
               toast.success("Process activated!")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinner(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinner(false);
         });
   }

   function DeleteProc() {
      setSpinner(true);
      api.post(`MachineSetup/DeleteProcess/${editId}`)
         .then((response) => {
            if (response.data.success) {
               toast.success("Process was successfully deleted or made inactive!")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinner(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinner(false);
         });
   }

   function onCreateProcess() {
      resetBasics();
      setAdd(true);
      setNew(INIT_MODEL);
   }

   function onLaborRateChange(val) {
      setLabor(val);
      let changes = Object.assign({}, isAdd ? newProcess : editProcess);
      changes.laborRatePerHour = val;
      if (isAdd) setNew(changes);
      else setEdit(changes);
   }

   function onMachRateChange(val) {
      setMachRate(val);
      let changes = Object.assign({}, isAdd ? newProcess : editProcess);
      changes.machineRatePerHour = val;
      if (isAdd) setNew(changes);
      else setEdit(changes);
   }

   function onNameChange(name) {
      setName(name);
      let changes = Object.assign({}, isAdd ? newProcess : editProcess);
      changes.process = name;
      if (isAdd) setNew(changes);
      else setEdit(changes);
   }

   function onOHRateChange(val) {
      setOverhead(val);
      let changes = Object.assign({}, isAdd ? newProcess : editProcess);
      changes.overheadRatePerHour = val;
      if (isAdd) setNew(changes);
      else setEdit(changes);
   }

   function onPkgSizeChange(val) {
      setPkg(val);
      let changes = Object.assign({}, isAdd ? newProcess : editProcess);
      changes.stdPkgSize = val;
      if (isAdd) setNew(changes);
      else setEdit(changes);
   }

   function onPPHChange(val) {
      setPPH(val);
      let changes = Object.assign({}, isAdd ? newProcess : editProcess);
      changes.stdPPH = val;
      if (isAdd) setNew(changes);
      else setEdit(changes);
   }

   function onSpeedChange(val) {
      setSpeed(val);
      let changes = Object.assign({}, isAdd ? newProcess : editProcess);
      changes.stdSpeed = val;
      if (isAdd) setNew(changes);
      else setEdit(changes);
   }

   function onSpindleChange(val) {
      setSpindles(val);
      let changes = Object.assign({}, isAdd ? newProcess : editProcess);
      changes.stdSpindles = val;
      if (isAdd) setNew(changes);
      else setEdit(changes);
   }

   function onStepChange(val) {
      setStep(val);
      let changes = Object.assign({}, isAdd ? newProcess : editProcess);
      changes.step = val;
      if (isAdd) setNew(changes);
      else setEdit(changes);
   }

   function onProcChange(newFilterValue) {
      setAdd(false);
      setNew(INIT_MODEL);
      const p = _.find(processList, (x) => x.value === newFilterValue.value);

      if (newFilterValue.value <= 0) {
         resetBasics();
      }
      else {
         setLabor(p.laborRatePerHour);
         setMachRate(p.machineRatePerHour);
         setOverhead(p.overheadRatePerHour);
         setName(p.process);
         setPkg(p.stdPkgSize);
         setPPH(p.stdPPH);
         setSpeed(p.stdSpeed);
         setSpindles(p.stdSpindles);
         setStep(p.step);

         let changes = Object.assign({}, INIT_MODEL);
         changes.id = newFilterValue.value;
         changes.isActive = p.isActive;
         changes.laborRatePerHour = p.laborRatePerHour;
         changes.machineRatePerHour = p.machineRatePerHour;
         changes.overheadRatePerHour = p.overheadRatePerHour;
         changes.process = newFilterValue.label;
         changes.stdPkgSize = p.stdPkgSize;
         changes.stdPPH = p.stdPPH;
         changes.stdSpeed = p.stdSpeed;
         changes.stdSpindles = p.stdSpindles;
         changes.step = p.step;
         setEdit(changes);
         //console.log(changes);
      }
      let newFilters = filterHelpers.getFilters(filters, {
         filterName: "process",
         value: p,
      });
      setFilters(newFilters);
      setEditId(newFilterValue.value <= 0 ? 0 : newFilterValue.value);
   }

   function resetBasics() {
      setEdit(INIT_MODEL);
      setEditId(0);
      setLabor("");
      setMachRate("");
      setOverhead("");
      setName("");
      setPkg("");
      setPPH("");
      setSpeed("");
      setSpindles("");
      setStep("");

      const p = _.find(processList, (x) => x.value === -1);
      let newFilters = filterHelpers.getFilters(filters, {
         filterName: "process",
         value: p,
      });
      setFilters(newFilters);
   }

   function runQuery() {
      setSpinner(true);
      api
         .fetch(`MachineSetup/LoadAllProcesses`)
         .then((response) => {
            if (response.data.success) {
               const pList = _.concat([ALL_OPTS],
                  helpers.addLabelProcessStepList(response.data.processes));
               return { pList: pList };
            } else {
               toast.error(response.data.message);
            }
         })
         .then(({ pList }) => {
            setProcessList(pList);
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
         })
         .finally(() => {
            resetBasics();
            setAdd(false);
            setNew(INIT_MODEL);
            setSpinner(false);
         });
   }

   function SaveProc() {
      let payload = Object.assign({}, isAdd ? newProcess : editProcess);
      if (!procName || procName === "" || procName.length < 3) {
         toast.error("Process name is required and must have at least 3 characters");
         return;
      }

      if (!step || step === "") {
         toast.error("Process step # is required");
         return;
      }
      else {
         let num = parseInt(step, 10);
         if (Number.isNaN(num) || !Number.isInteger(num) || num <= 0) {
            toast.error("Process step # must be numeric and greater than 0");
            return;
         }
      }

      if (!labor || labor === "") {
         toast.error("Labor rate is required");
         return;
      }
      else {
         let num = parseFloat(labor);
         if (Number.isNaN(num) || num <= 0) {
            toast.error("Labor rate must be numeric and greater than 0");
            return;
         }
      }

      if (!machRate || machRate === "") {
         toast.error("Machine rate is required");
         return;
      }
      else {
         let num = parseFloat(machRate);
         if (Number.isNaN(num) || num <= 0) {
            toast.error("Machine rate must be numeric and greater than 0");
            return;
         }
      }

      if (!ohRate || ohRate === "") {
         toast.error("Overhead rate is required");
         return;
      }
      else {
         let num = parseFloat(ohRate);
         if (Number.isNaN(num) || num <= 0) {
            toast.error("Overhead rate must be numeric and greater than 0");
            return;
         }
      }

      if (!pph || pph === "") {
         toast.error("Standard PPH is required");
         return;
      }
      else {
         let num = parseInt(pph, 10);
         if (Number.isNaN(num) || !Number.isInteger(num) || num <= 0) {
            toast.error("Standard PPH must be numeric and greater than 0");
            return;
         }
      }

      payload.process = procName;
      payload.step = step;
      payload.laborRatePerHour = labor;
      payload.machineRatePerHour = machRate;
      payload.overheadRatePerHour = ohRate;
      payload.stdPPH = pph;
      payload.stdPkgSize = pkgSize === "" ? 0 : pkgSize;
      payload.stdSpeed = speed === "" ? 0 : speed;
      payload.stdSpindles = spindles === "" ? 0 : spindles;
      setSpinner(true);

      if (isAdd) {
         api.post('MachineSetup/SaveProcess', payload)
            .then((response) => {
               if (response.data.success) {
                  toast.success("Process saved!")
                  runQuery();
               } else {
                  toast.error(response.data.message);
                  setSpinner(false);
               }
            })
            .catch((error) => {
               api.catchHandler(error);
               toast.error(error);
               setSpinner(false);
            });
      }
      else {
         api.post('MachineSetup/UpdateProcess', payload)
            .then((response) => {
               if (response.data.success) {
                  toast.success("Process updated!")
                  runQuery();
               } else {
                  toast.error(response.data.message);
                  setSpinner(false);
               }
            })
            .catch((error) => {
               api.catchHandler(error);
               toast.error(error);
               setSpinner(false);
            });
      }
   }

   const ShowDeleteModal = () => {
      if (editId <= 1) { // 1 is default process and cannot be deleted
         toast.error("Please select a valid process to delete");
         return;
      }
      confirmAlert({
         title: "Confirm Deletion or Inactivation",
         message: `Are you sure you want to delete the ${editProcess.process} process?`,
         buttons: [
            { label: "Yes", onClick: () => { DeleteProc() }},
            { label: "No" }
         ]
      });
   }

   return (
      <Container fluid>
         <Row>
            <Col>
               <Fragment>
                  <ServiceThreadSpinner on={spin}>
                     <Row className="px-2 py-2">
                        <Col xxl={{ offset: 0, size: 12 }}>
                           <Button title="Add" className="shredButton" onClick={() => onCreateProcess()}>
                              Add New Process
                           </Button>
                        </Col>
                     </Row>
                     <Row className="px-2 py-2">
                        <Col xxl={{ offset: 0, size: 12 }}>
                           {processList && processList.length ? (
                              <Table className="transparent-background my-0">
                                 <tbody>
                                    <tr>
                                       <td className="transparent-background data-cell noWrap h6" width="80px">
                                          Process:
                                       </td>
                                       <td className="transparent-background" width="500px">
                                          <FilterSelect
                                             filterName="process"
                                             options={processList}
                                             value={filterHelpers.getValue(filters, "process")}
                                             onChangeCallback={e => onProcChange(e)}
                                          />
                                       </td>
                                       <td className="transparent-background"></td>
                                    </tr>
                                 </tbody>
                              </Table>
                           ) : null}
                        </Col>
                     </Row>
                     <hr />

                     {isAdd || editId > 0 ? (
                        <div>
                           <Row className="px-0 py-0">
                              <Table className="transparent-background data-table">
                                 <tbody>
                                    {editProcess && editId > 1 ? (
                                       <tr>
                                          <td className="transparent-background data-cell width40px"></td>
                                          <td colSpan={3} className="transparent-background data-cell noWrap h6">
                                             Deleting a process that has MSR machine types assigned to it will set it to inactive.
                                          </td>
                                       </tr>
                                    ): null}
                                    {editId === 1 ? (
                                       <tr>
                                          <td className="transparent-background data-cell width40px"></td>
                                          <td colSpan={3} className="transparent-background data-cell noWrap h5 text-green">
                                             This is the default process and cannot be changed or deleted
                                          </td>
                                       </tr>
                                    ) : null}
                                    {editProcess && editId > 0 ? (
                                       <tr>
                                          <td className="transparent-background data-cell width40px"></td>
                                          <td className="transparent-background data-cell width225px noWrap h6">
                                             Id: {editId}
                                          </td>
                                          <td className="transparent-background data-cell width95px noWrap h6">
                                             Active:  {editProcess.isActive ? "Yes" : "No"}
                                          </td>
                                          <td className="transparent-background"></td>
                                       </tr>
                                    ) : null}
                                    {editId === 1 ? (
                                       <tr>
                                          <td className="transparent-background data-cell width40px"></td>
                                          <td className="transparent-background data-cell width225px noWrap h6">
                                             Step:  {step}
                                          </td>
                                          <td className="transparent-background data-cell width95px noWrap h6">
                                             Name: {procName}
                                          </td>
                                          <td className="transparent-background"></td>
                                       </tr>
                                    ) : null}
                                    {editId !== 1 ? (
                                       <tr>
                                          <td className="transparent-background data-cell width40px"></td>
                                          <td className="transparent-background data-cell width225px noWrap h6">
                                             Name:
                                          </td>
                                          <td className="transparent-background data-cell width500px">
                                             <Input
                                                type="text"
                                                value={procName || ""}
                                                onChange={(e) => onNameChange(e.target.value)}
                                                maxLength="99"
                                                disabled={!editProcess?.enabled}
                                             />
                                          </td>
                                          <td className="transparent-background"></td>
                                       </tr>
                                    ) : null}
                                    {editId !== 1 ? (
                                       <tr>
                                          <td className="transparent-background data-cell width40px"></td>
                                          <td className="transparent-background data-cell width225px noWrap h6">
                                             Step #:
                                          </td>
                                          <td className="transparent-background data-cell width500px">
                                             <Input
                                                type="text"
                                                value={step || ""}
                                                onChange={(e) => onStepChange(e.target.value)}
                                                maxLength="2"
                                             />
                                          </td>
                                          <td className="transparent-background"></td>
                                       </tr>
                                    ) : null}
                                    {editId !== 1 ? (
                                       <tr>
                                          <td className="transparent-background data-cell width40px"></td>
                                          <td className="transparent-background data-cell width225px noWrap h6">
                                             Machine Rate $/hr:
                                          </td>
                                          <td className="transparent-background data-cell width500px">
                                             <Input
                                                type="text"
                                                value={machRate || ""}
                                                onChange={(e) => onMachRateChange(e.target.value)}
                                                maxLength="7"
                                             />
                                          </td>
                                          <td className="transparent-background"></td>
                                       </tr>
                                    ) : null}
                                    {editId !== 1 ? (
                                       <tr>
                                          <td className="transparent-background data-cell width40px"></td>
                                          <td className="transparent-background data-cell width225px noWrap h6">
                                             Labor Rate $/hr:
                                          </td>
                                          <td className="transparent-background data-cell width500px">
                                             <Input
                                                type="text"
                                                value={labor || ""}
                                                onChange={(e) => onLaborRateChange(e.target.value)}
                                                maxLength="7"
                                             />
                                          </td>
                                          <td className="transparent-background"></td>
                                       </tr>
                                    ) : null}
                                    {editId !== 1 ? (
                                       <tr>
                                          <td className="transparent-background data-cell width40px"></td>
                                          <td className="transparent-background data-cell width225px noWrap h6">
                                             OH Rate $/hr:
                                          </td>
                                          <td className="transparent-background data-cell width500px">
                                             <Input
                                                type="text"
                                                value={ohRate || ""}
                                                onChange={(e) => onOHRateChange(e.target.value)}
                                                maxLength="7"
                                             />
                                          </td>
                                          <td className="transparent-background"></td>
                                       </tr>
                                    ) : null}
                                    {editId !== 1 ? (
                                       <tr>
                                          <td className="transparent-background data-cell width40px"></td>
                                          <td className="transparent-background data-cell width225px noWrap h6">
                                             Std Pkg Size (lbs):
                                          </td>
                                          <td className="transparent-background data-cell width500px">
                                             <Input
                                                type="text"
                                                value={pkgSize || ""}
                                                onChange={(e) => onPkgSizeChange(e.target.value)}
                                                maxLength="7"
                                             />
                                          </td>
                                          <td className="transparent-background"></td>
                                       </tr>
                                    ) : null}
                                    {editId !== 1 ? (
                                       <tr>
                                          <td className="transparent-background data-cell width40px"></td>
                                          <td className="transparent-background data-cell width225px noWrap h6">
                                             Std PPH (if applicable):
                                          </td>
                                          <td className="transparent-background data-cell width500px">
                                             <Input
                                                type="text"
                                                value={pph || ""}
                                                onChange={(e) => onPPHChange(e.target.value)}
                                                maxLength="7"
                                             />
                                          </td>
                                          <td className="transparent-background"></td>
                                       </tr>
                                    ) : null}
                                    {editId !== 1 ? (
                                       <tr>
                                          <td className="transparent-background data-cell width40px"></td>
                                          <td className="transparent-background data-cell width225px noWrap h6">
                                             Std Spindle Speed:
                                          </td>
                                          <td className="transparent-background data-cell width500px">
                                             <Input
                                                type="text"
                                                value={speed || ""}
                                                onChange={(e) => onSpeedChange(e.target.value)}
                                                maxLength="7"
                                             />
                                          </td>
                                          <td className="transparent-background"></td>
                                       </tr>
                                    ) : null}
                                    {editId !== 1 ? (
                                       <tr>
                                          <td className="transparent-background data-cell width40px"></td>
                                          <td className="transparent-background data-cell width225px noWrap h6">
                                             Std Spindle Count:
                                          </td>
                                          <td className="transparent-background data-cell width500px">
                                             <Input
                                                type="text"
                                                value={spindles || ""}
                                                onChange={(e) => onSpindleChange(e.target.value)}
                                                maxLength="7"
                                             />
                                          </td>
                                          <td className="transparent-background"></td>
                                       </tr>
                                    ) : null}
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td className="transparent-background data-cell width225px"></td>
                                       <td className="transparent-background data-cell width500px">
                                          {isAdd || editId > 1 ? (
                                             <Button
                                                title="New Process"
                                                className="shredButtonExcel ms-2"
                                                onClick={() => SaveProc()}
                                             >Save
                                             </Button>
                                          ) : null}
                                          &nbsp;&nbsp;&nbsp;
                                          {editId > 1 && editProcess?.isActive ? (
                                             <Button
                                                title="Delete"
                                                className="shredButton buttonRight"
                                                onClick={() => ShowDeleteModal()}
                                             >Delete
                                             </Button>
                                          ) : null}
                                          {editId > 1 && !editProcess?.isActive ? (
                                             <Button
                                                title="Reactivate"
                                                className="shredButton"
                                                onClick={() => ActivateProc()}
                                             >Reactivate
                                             </Button>
                                          ): null}
                                       </td>
                                       <td className="transparent-background"></td>
                                    </tr>
                                 </tbody>
                              </Table>
                           </Row>
                        </div>
                     ) : null}
                  </ServiceThreadSpinner>
               </Fragment>
            </Col>
         </Row>
      </Container>
   );
}
